import { Input,Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatTableDataSource } from '@angular/material';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { AppComponent } from 'src/app/app.component';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { DatePipe } from '@angular/common';
import { AppCurrencyPipeModule } from 'src/app/services/CommonService/custom.currency.pipe';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { AppSettings } from 'src/app/shared/AppSettings';
import { tJournalService } from 'src/app/services/tJournal.service';
import { JournalEditPageSearchResultModel, JournalInsertModel, tJournalModel } from 'src/app/models/tJournalModel';
import { tEmployeeModel } from 'src/app/models/tEmployeeModel';
import { tVendorModel } from 'src/app/models/tVendorModel';
import { GLSettingService } from 'src/app/services/Accounting/GLSetting.service';
import { GLSettingModel } from 'src/app/models/Accounting/tGLSettingModel';
import {tAnalysisService} from 'src/app/services/tAnalysis.service';
import { analysisModel} from 'src/app/models/Accounting/tAnalysisModel';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.css']
})
export class VoucherComponent implements OnInit {
  @Input() voucherNumber: string;
  
  TAG = "EditJournalComponent";
  dataList: JournalInsertModel[] = new Array;
  dataSource: MatTableDataSource<JournalInsertModel> = new MatTableDataSource<JournalInsertModel>();

  DisplayFC:boolean = false;
  //header
  header_JournalType="";
  header_JnlDate="";
  header_vouNo="";
  header_Vendor="";
  header_Emp="";
  header_remark="";
  header_chequeNo="";
  header_aysID="";

  Analysis1Title="";

  lastUpdateUser="";
  footerDrTotal=0;
  footerCrTotal=0;
  DisplayFCvoucher;


  DisplayHeader_Vendor;
  DisplayHeader_Emp;
  DisplayHeader_remark;
  DisplayHeader_chequeNo;
  DisplayHeader_aysID;


  tGLData:GLSettingModel;
  analysisData:analysisModel[]=new Array;

  constructor(
    public activeModal: NgbActiveModal,
    private dateTimeConvertService: DateTimeConvertService,
    private log: LoggerService,
    private datepipe: DatePipe,
    private journalService: tJournalService,
    private glSettingService: GLSettingService,
    private analysisService:tAnalysisService,
  ) { }
  
  ngOnInit() {
    this.log.i("vouNo",this.voucherNumber);
    this.log.i("DisplayFC",this.DisplayFC);
    this.getGLSettingInfo();
    this.getAnalysisData();
    this.getVoucherData(this.voucherNumber);
  }

  getGLSettingInfo() {
    this.glSettingService.getAllDataByShopID(NavigationComponent.selectedShopID.toString()).subscribe((data: GLSettingModel[]) => {
      this.log.i(this.TAG, 'glSettingService data length = ' + data.length);
      if (data.length > 0) {
        this.tGLData=data[0];
        this.Analysis1Title=this.tGLData.namedAnalysis1;
      }
      

    });
  }
  getAnalysisData(){
    this.analysisService.getAllData().subscribe(data =>{
      this.analysisData=data;
    });
  }
  getVoucherData(vouchNumber:string){
    this.journalService.getDataByVoucherID(vouchNumber).subscribe((data: JournalEditPageSearchResultModel) => {
      this.log.i(this.TAG, 'getVoucherData data = ' + JSON.stringify(data));
      if (data.journalList.length > 0) {

        this.dataList = data.journalList as JournalInsertModel[];
        this.dataSource = new MatTableDataSource<JournalInsertModel>(this.dataList);
        var firstModel :JournalInsertModel = data.journalList[0] as JournalInsertModel;
        this.header_Vendor=data.vendorName;
        this.header_Emp=data.employeeName;
        this.header_aysID=data.journalList[0].analysis1;
        this.getHeader();
      }else{
        //TODO do error msg and return
      }


    });
 }
 cancel() {
  // this.log.i(this.TAG, "do cancel");
  this.activeModal.close('Close click');
  }

  getHeader(){
    //get Voucher Type
    if(this.dataList[0].vouType=="JV"){
      this.header_JournalType="JOURNAL VOUCHER";
    }
    else
    if(this.dataList[0].vouType=="PV"){
      this.header_JournalType="PAYMENT VOUCHER";
    }
    else
    if(this.dataList[0].vouType=="OP"){
      this.header_JournalType="OPENING VOUCHER";
    }

    this.header_JnlDate=this.datepipe.transform(this.dataList[0].jnlDate, 'dd/MM/yyyy');
    this.header_vouNo=this.voucherNumber;
    this.header_remark=this.dataList[0].refNo;
    this.header_chequeNo=this.dataList[0].chequeNo;
    this.lastUpdateUser=this.dataList[0].lastModifyUserID;
    for(let i=0;i<this.dataList.length;i++){
      this.footerDrTotal=this.footerDrTotal+this.dataList[i].drAmtBase;
      this.footerCrTotal=this.footerCrTotal+this.dataList[i].crAmtBase;
    }
    this.getVoucherChange();
    this.getVoucherType(this.dataList[0].vouType);
  }

  getVoucherChange(){
    if(this.DisplayFC==false){
      this.DisplayFCvoucher=true;
    }else{
      this.DisplayFCvoucher=false;
    }
  }
  /*
  
  DisplayHeader_Vendor;
  DisplayHeader_Emp;
  DisplayHeader_remark;
  DisplayHeader_chequeNo;
  DisplayHeader_aysID;
  */
  getVoucherType(type:string){

    if(type=="JV"){
      this.DisplayHeader_Vendor=false;
      this.DisplayHeader_Emp=false;
    }else{
      this.DisplayHeader_Vendor=true;
      this.DisplayHeader_Emp=true;
      this.DisplayHeader_remark=true;
      this.DisplayHeader_chequeNo=true;
      this.DisplayHeader_aysID=true;
    }

    if(type=="OP"){
      this.DisplayHeader_Vendor=false;
      this.DisplayHeader_Emp=false;
      this.DisplayHeader_remark=false;
      this.DisplayHeader_chequeNo=false;
      this.DisplayHeader_aysID=false;
    }else{
      this.DisplayHeader_Vendor=true;
      this.DisplayHeader_Emp=true;
      this.DisplayHeader_remark=true;
      this.DisplayHeader_chequeNo=true;
      this.DisplayHeader_aysID=true;
    }
  }
  /*
   printPDF() {


     const elementToPrint = document.getElementById('print'); // The html element to become a pdf

    // const pdf = new jsPDF('p', 'pt', 'a4');

   const pdf = new jsPDF({
     orientation: 'landscape'
   });




     pdf.addHTML(elementToPrint, () => {
          pdf.output('dataurlnewwindow');
         pdf.save('web.pdf');
     });




   var data = document.getElementById('print');
   var date = new Date();
   html2canvas(data).then(canvas => {
   var imgWidth = 210;
   var pageHeight = 295;
   var imgHeight = canvas.height * imgWidth ;
   var heightLeft = imgHeight;



  const imgData = canvas.toDataURL('image/png');

   let doc = new jsPDF('p', 'mm');
   let position = 0;

   doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight +15);
   heightLeft -= pageHeight;

   while (heightLeft >= 0) {
     position = heightLeft - imgHeight;
     doc.addPage();
     doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight + 15);
     heightLeft -= pageHeight;
   }
   doc.save (date.getTime()+'.pdf');
   });





/*
   const elementHandler = {
     '#ignorePDF': function (element, renderer) {
       return true;
     }
   };
   var source = document.getElementsByTagName('body')[0];
   doc.fromHTML(
       source,
       15,
       15,
      {
         'width': 180, 'elementHandlers': null
       });

   doc.output('dataurlnewwindow');


   doc.text('Hello world!', 1, 1);
   doc.save('two-by-four.pdf');
  }*/

}
